<template>
  <div
    :style="{ width: width + 'px', height: height + 'px' }"
    class="electrocardiogram"
  >
    <video
      id="jswebrtc2"
      ref="jswebrtc2"
      controls
      style="width: 100%;height: 100%;object-fit: fill"
    />
  </div>
</template>

<script>
export default {
  name: "Electrocardiogram",
  props: {
    diogramWidth: {
      type: Number,
      default: 600,
    },
    diogramHeight: {
      type: Number,
      default: 500,
    },
    videoSrc: {
      type: String,
      default: "",
    },
  },
  data() {
    return {
      width: this.diogramWidth,
      height: this.diogramHeight,
      player: null
    };
  },
  watch: {
    $route(to, from) {
      if (this.player) {
        this.player.destroy();
      }
    }
  },
  mounted() {
    this.$watch("videoSrc", () => {
      const isNone = this.videoSrc.replace("webrtc://", "");
      if (!isNone) return;
      const canPlay = this.videoSrc.indexOf("token") !== -1;
      if (canPlay) {
        this.initVideo(this.videoSrc);
        console.log("播放视频路径：", this.videoSrc);
      }
    }, { immediate: true });
  },

  methods: {
    /**
     * 初始化播放器并播放
     * 两种调用方式
     *  一种通过 watch监听 props 传过来的 src 进行播放
     *  一种通过 引用组件上的 ref 直接调用 initVideo 如 this.$refs.webrtc.initVideo('src')
     * */

    initVideo(url) {
      // 播放器存在 清空重置
      if (this.player) {
        this.player.destroy();
        this.player = null;
      }

      // 获取承载元素dom
      const videoDom = document.getElementById("jswebrtc2");

      // 初始化播放器
      this.player = new JSWebrtc.Player(url,
        {
          video: videoDom,
          autoplay: true,
          onPlay: (obj) => {
            // 监听video元素状态，可播放时进行播放 。 某些情况下  autoplay 会失效
            // mdn https://developer.mozilla.org/zh-CN/docs/Web/API/HTMLMediaElement/canplay_event
            // 菜鸟 https://www.runoob.com/tags/av-event-canplay.html
            videoDom.addEventListener("canplay", function(e) {
              videoDom.play();
            });
            console.log(obj, "播放器开始播放！");
          }
        });
    }
  },

};
</script>

<style scoped>

</style>
